<script>
    export let placeholder='placeholder', area, index, field_store_name, padding_top='0px', align='center', text='left', updateCallback, value;


</script>

<label for={placeholder} class="field" style="--area: {area}; --text-align: {text}; --align-self: {align}; --padding_top:{padding_top};">
    <input type="text" value={value} name={placeholder} required on:blur={(val) => {updateCallback(index, field_store_name, val.target.value)}}/>
    <span class="placeholder">{placeholder}</span>
</label>

<style lang="scss">
    @use "styles/global.scss";
    $height: 1.2em;
    $side-padding: 0.5em;

    .field{
        grid-area: var(--area);

        position: relative;
        pointer-events: none;
        font: inherit;
        align-self: var(--align-self);

        padding: 0px $side-padding;
        //padding-top: 88px;
        padding-top: var(--padding_top);

        input{
            @include input_text_no_style;
            width: 100%;
            height: $height;
            //margin-top: calc(50% - #{$height}*1.5);

            justify-self: stretch;
            //align-self: var(--align-self);
            text-align: var(--text-align);
            text-transform:none;
            /*
            &::first-letter{
                text-transform:capitalize;
            }
            */

            pointer-events:all;
            
            font-size: 18px;

            &:valid + .placeholder,
            &:focus + .placeholder{
                //top: $padding;
                transform: translateY(-1.5 * $height);
                font-size: 14px;
            }
        }
        
        .placeholder{
            position: absolute;
            left: 0 + $side-padding;
            top: var(--margin_top);
            //top: calc(50% + #{$height}/2);
            //transform: translateY(-50%);

            width: auto;
            justify-self: stretch;
            //align-self: var(--align-self);
            text-align: var(--text-align);

            color: $grey5;
            font-size: 18px;

            transition: 0.3s ease;
        }
    }
</style>